export const snakeToCamel = (str: string): string => {
  return str.replace(/_([a-zA-Z0-9])/g, (_, letter) => letter.toUpperCase());
};

export const extractValue = (obj: { value: any }): any => {
  return obj ? obj.value : null;
};
export const getItemsByKeyPrefix = (
  obj: Record<string, any>,
  prefix: string,
): Record<string, any> => {
  if (!obj || typeof obj !== "object") {
    console.warn(
      "getItemsByKeyPrefix: obj is null, undefined, or not an object",
      { obj, prefix },
    );
    return {};
  }

  return Object.entries(obj)
    .filter(([key]) => key.startsWith(prefix))
    .reduce(
      (acc, [key, value]) => {
        const reducedKey = snakeToCamel(key.slice(prefix.length));
        const finalKey =
          reducedKey.charAt(0).toLowerCase() + reducedKey.slice(1);
        acc[finalKey] =
          value !== null && value !== undefined
            ? typeof value === "string"
              ? value
              : value?.value
            : "";
        return acc;
      },
      {} as Record<string, any>,
    );
};

export const getArrayByKeyPrefix = (
  obj: Record<string, any>,
  prefix: string,
): string[] => {
  if (!obj || typeof obj !== "object") return [];

  return Object.entries(obj)
    .filter(([key]) => key.startsWith(prefix))
    .map(([key, value]) => {
      const raw = key.slice(prefix.length); // ldapServer0
      const indexMatch = raw.match(/\d+$/);
      const index = indexMatch ? Number(indexMatch[0]) : 0;

      const finalValue =
        value == null
          ? ""
          : typeof value === "object" && "value" in value
            ? value.value
            : value;

      return { index, value: finalValue };
    })
    .sort((a, b) => a.index - b.index)
    .map((item) => item.value);
};

export const getYesNoAsBoolean = (
  val: number | string,
): boolean | undefined => {
  if (val === 1 || val === "1") return false;
  if (val === 0 || val === "0") return true;
  return undefined;
};
/**
 * A feature switch as a catalog SECTION sees it while it is being built.
 *
 * The catalog is constructed before `factsFromObject` loads the stored answers
 * into it, so at construction every question still reads unanswered. A section
 * that is shown or hidden by a switch therefore needs both: the live question,
 * so toggling it takes effect at once, and the stored answer, for the state the
 * questionnaire opens in. An unanswered question must fall through to the
 * stored value - reading it as a No hides the section on every open of a
 * questionnaire that has the feature switched on.
 */
export const featureSwitchValue = (
  raw: number | string | undefined | null,
  stored: boolean,
): boolean =>
  (raw === undefined || raw === null ? undefined : getYesNoAsBoolean(raw)) ??
  stored;

export const getKeyAsYesNoBoolean = (
  obj: Record<string, any>,
  keys: string[],
): Record<string, any> => {
  const result = { ...obj };
  for (const key of keys) {
    if (key in result) {
      result[key] = getYesNoAsBoolean(result[key]);
    }
  }
  return result;
};
